interface IQuestion {
  title: string,
  pst_question_answers: Array<{
    answer: string
  }>
}

export enum PersonalStatementState {
    NOT_STARTED = 'notStarted',
    STARTED = 'started',
    COMPLETED = 'completed',
}

export default interface IPersonalStatement {
    questions: IQuestion[],
    statement: string,
    wordCount: number,
    state: PersonalStatementState,
}
